import { render, staticRenderFns } from "./GameMobile.vue?vue&type=template&id=9a6766e0&scoped=true"
import script from "./GameMobile.vue?vue&type=script&lang=js"
export * from "./GameMobile.vue?vue&type=script&lang=js"
import style0 from "./GameMobile.vue?vue&type=style&index=0&id=9a6766e0&prod&lang=scss&scoped=true"
import style1 from "./GameMobile.vue?vue&type=style&index=1&id=9a6766e0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a6766e0",
  null
  
)

export default component.exports